'use client'

import type {
  OrchestratedOfferingListingDetails,
  OrchestratedAuctionListingDetails,
} from '@b-stock/fe-core/bstock-next/queries'

import {
  getTopLotCategory,
  getLotCategories,
} from '@/buyer-portal/helpers/lot/categories'
import { getLotConditions } from '@/buyer-portal/helpers/lot/conditions'

import { SimilarListingsCard } from './SimilarListingsCard'
import { SimilarListingsSectionOrSidebar } from './SimilarListingsSectionOrSidebar'
import type { SimilarListingsVariant } from './useSearchSimilarListingsHandler'

export const SearchSimilarListings = ({
  listing,
  variant = 'sidebar',
}: {
  listing:
    | OrchestratedOfferingListingDetails
    | OrchestratedAuctionListingDetails
  variant?: SimilarListingsVariant
}) => {
  const promoteOtherListings = listing.promoteOtherListings

  if (promoteOtherListings !== 'all' && promoteOtherListings !== 'own') {
    return null
  }

  const categories = getLotCategories(listing.lot)
  const condition = getLotConditions(listing.lot)
  const searchQuery = getTopLotCategory(listing.lot)
  const storefront =
    listing.storefrontId && listing.seller.storefront?.name
      ? { id: listing.storefrontId, name: listing.seller.storefront.name }
      : undefined

  return variant === 'card' ? (
    <SimilarListingsCard
      categories={categories}
      condition={condition}
      promoteOtherListings={promoteOtherListings}
      searchQuery={searchQuery}
      storefront={storefront}
    />
  ) : (
    <SimilarListingsSectionOrSidebar
      categories={categories}
      condition={condition}
      promoteOtherListings={promoteOtherListings}
      searchQuery={searchQuery}
      storefront={storefront}
      variant={variant}
    />
  )
}
